import type { Measurement, Metrics, MetricState, MetricView, Platform, PostMeasurement } from '../api/types'

export function metricView(params: URLSearchParams): MetricView | undefined {
  const value = params.get('metric_view')
  return value === 'meta' || value === 'legacy' ? value : undefined
}

export function postMeasurement(params: URLSearchParams): PostMeasurement {
  const value = params.get('context_source_id')
  const context = Number(value)
  return { ...(metricView(params) ? { metric_view: metricView(params) } : {}),
    ...(value && Number.isSafeInteger(context) && context > 0 ? { context_source_id: context } : {}) }
}

export function postHref(post: { id: number } & Measurement, fallback?: PostMeasurement): string {
  const query = new URLSearchParams()
  const view = post.metric_view ?? fallback?.metric_view
  const context = post.context_source_id ?? fallback?.context_source_id
  if (view) query.set('metric_view', view)
  if (context != null) query.set('context_source_id', String(context))
  return `/post/${post.id}${query.size ? '?' + query.toString() : ''}`
}

/** Запрет смешения семантик действует и при null, missing, hidden и нуле. */
export function primaryViews(post: { metrics: Metrics } & Measurement): number | null {
  return post.metric_view === 'meta' ? post.metrics.views ?? null : post.metrics.plays
}

export function viewsLabel(post: { platform: Platform } & Measurement): string {
  return post.platform === 'instagram'
    ? post.metric_view === 'meta' ? 'Просмотры Meta' : 'Просмотры Apify'
    : 'Просмотры'
}

export function metricStateLabel(state: MetricState | undefined): string {
  return state === 'hidden' ? 'скрыто' : state === 'unsupported' ? 'не предоставляется'
    : state === 'error' ? 'недоступно' : 'нет данных'
}

export function isMeta(post: Measurement): boolean { return post.metric_view === 'meta' }

export function seriesLabel(post: Measurement): string {
  return isMeta(post) ? 'Meta · публичные счётчики' : 'Apify · прежняя серия'
}

/** Только подтверждённое обновление Meta views может называться его успехом. */
export function refreshResultMessage(result: unknown): string {
  if (!result || typeof result !== 'object') return 'Обновление готово'
  const value = result as Record<string, unknown>
  if (value.operation === 'meta_metrics' || value.operation === 'meta_metrics_refresh') {
    return value.metric_view === 'meta' && value.primary_metrics_updated === true
      && Array.isArray(value.updated_fields) && value.updated_fields.includes('views')
      ? 'Просмотры Meta обновлены' : 'Проверка Meta завершена'
  }
  return value.operation === 'apify_enrich' ? 'Обогащение готово' : 'Обновление готово'
}
